"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MangoPayErrorCode = void 0;
var MangoPayErrorCode;
(function (MangoPayErrorCode) {
    MangoPayErrorCode["TransactionRefusedByBank"] = "101101";
    MangoPayErrorCode["TransactionRefusedAmountLimit"] = "101102";
    MangoPayErrorCode["ThreeDSecureUnathorized"] = "101301";
    MangoPayErrorCode["ThreeDSecureNotAvailable"] = "101399";
    MangoPayErrorCode["TransactionRefusedCardLimit"] = "101104";
    MangoPayErrorCode["TransactionRefused"] = "101199";
    MangoPayErrorCode["InvalidCardNumber"] = "105101";
    MangoPayErrorCode["CardExpired"] = "101105";
    MangoPayErrorCode["TechnicalError"] = "009199";
    MangoPayErrorCode["UnsupportedCountry"] = "008508";
    // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
    MangoPayErrorCode["ThreeDSecureAuthNotAvailable"] = "101399";
    MangoPayErrorCode["FraudSuspectedByTheBank"] = "008006";
    MangoPayErrorCode["WalletBlockedByFraudPolicy"] = "008600";
    MangoPayErrorCode["UserBlockedByFraudPolicy"] = "008700";
    MangoPayErrorCode["SuspicionOfFraud"] = "008999";
    MangoPayErrorCode["TransactionBlockedByFraudPolicy"] = "008500";
    MangoPayErrorCode["InsufficientFunds"] = "001001";
})(MangoPayErrorCode || (exports.MangoPayErrorCode = MangoPayErrorCode = {}));
//# sourceMappingURL=MangoPayErrorCode.js.map